import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Moment from 'moment';
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_MachineProducePerformanceInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectDateType, setSelectDateType] = useState('E');
    const [dateTypeOption, setDateTypeOption] = useState([{ value: 'S', label:'시작일자' },{ value: 'E', label:'종료일자' }]);
    const [selectDate, setSelectDate] = useState(appStore.YYYY_MM_DD());
    const [fixProject, setFixProject] = useState(''); // 고정 데이터
    const [searchProject, setSearchProject] = useState(''); // 조회 데이터
    const [selectProject, setSelectProject] = useState('');
    const [selectProduceInputUserID, setSelectProduceInputUserID] = useState(0);
    const [selectProduceInputDateTime, setSelectProduceInputDateTime] = useState('');
    const [selectProduceInputYN, setSelectProduceInputYN] = useState('');
    const [selectProduceItemUseYN, setSelectProduceItemUseYN] = useState('N');
    const [selectProduceCount, setSelectProduceCount] = useState(0);
    const [selectProduceCompleteCount, setSelectProduceCompleteCount] = useState(0);
    const [selectProduceErrorCount, setSelectProduceErrorCount] = useState(0);
    const [projectOption, setProjectOption] = useState([]);
    const [InputItemRows, setInputItemRows] = useState([]);

    useEffect(() => {
        appStore.setLoading(true);

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
            appStore.setLoading(false);
        }, 800);
    }, []);

    useEffect(() => {
        // Mount 될때만 실행된다.
        if(params.project_id !== null && typeof params.project_id !== 'undefined'){
            setFixProject(params.project_id);
            setSearchProject(params.project_id);
        }
    }, []);

    useEffect(() => {
        setSelectProject(0);
        setSelectProduceInputUserID(0);
        setSelectProduceInputDateTime('');
        setSelectProduceInputYN('');
        setSelectProduceCount(0);
        setSelectProduceCompleteCount(0);
        setSelectProduceErrorCount(0);
        setProjectOption([]);
        handleInitSelect();
    }, [selectDateType, selectDate]);

    useEffect(() => {
        if(String(searchProject) !== ''){
            if(String(searchProject) !== String(selectProject)){
                setSelectProject(searchProject);
            }else{
                handleSelect();
            }
        }
    }, [searchProject]);
    
    useEffect(() => {
        if(selectProject == 0 || selectProject === ''){
            setSelectProduceInputUserID(0);
            setSelectProduceInputDateTime('');
            setSelectProduceInputYN('');
            setSelectProduceCount(0);
            setSelectProduceCompleteCount(0);
            setSelectProduceErrorCount(0);
            setInputItemRows([]);
        }else{
            handleSelect();
        }
    }, [selectProject]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            
        }
    }, [MenuID])

    const ProduceInputCountUpdate = (produceInputItemSeq, e, useStock, DPuseStock, UnitName) => {
        const {name, value} = e.target;
        if(Number(value) > Number(useStock)){
            alert('사용가능재고가 '+DPuseStock+UnitName+'이므로 '+DPuseStock+UnitName+'까지 변경할 수 있습니다.');
            setInputItemRows(InputItemRows.map(
                InputItemRows=>InputItemRows.produce_input_item_seq === produceInputItemSeq ? {...InputItemRows, produce_input_count:useStock} : InputItemRows
            ));
        }else{
            setInputItemRows(InputItemRows.map(
                InputItemRows=>InputItemRows.produce_input_item_seq === produceInputItemSeq ? {...InputItemRows, produce_input_count:value} : InputItemRows
            ));
        }
    };

    const ProduceCompleteCountUpdate = (e) => {
        if(selectProject === '' || selectProject === 0){
            alert('프로젝트 선택 후 수량 변경이 가능합니다.');
            return;
        }

        const {name, value} = e.target;

        var minus = (Number(value))
        if(minus < 0){
            minus = 0
        }

        setSelectProduceCompleteCount(minus);
    };

    const ProduceErrorCountUpdate = (e) => {
        if(selectProject === '' || selectProject === 0){
            alert('프로젝트 선택 후 수량 변경이 가능합니다.');
            return;
        }

        const {name, value} = e.target;

        var minus = (Number(value))
        if(minus < 0){
            minus = 0
        }

        setSelectProduceCompleteCount(Number(selectProduceCount) - Number(minus));
        if(minus === 0){
            minus = '';
        }
        setSelectProduceErrorCount(minus);
    };

    const handleInitSelect = () => {
        axios.get('/api/p/MachineProducePerformance/Select',
            {
                params : {
                    date : selectDate,
                    date_type : selectDateType
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            const optionArray = response.data.map((item, index) => 
                ({ value: item.machine_id+'$'+item.machine_project_id+'$'+Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')+'$'+Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss'), label: item.machine_name + ' / ' + item.project_name + ' / ' + item.produce_count+'EA' })
            );
            optionArray.unshift({ value: 0, label : '설비 / 프로젝트 / 생산수량' });
            setProjectOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const handleSelect = () => {
        setSearchProject('');
        const param_machine_id = (selectProject.split("$"))[0]
        const param_machine_project_id = (selectProject.split("$"))[1]
        const param_produce_start_datetime = (selectProject.split("$"))[2]
        const param_produce_end_datetime = (selectProject.split("$"))[3]
        
        axios.get('/api/p/MachineProducePerformance/SelectProject',
            {
                params : {
                    machine_id : param_machine_id,
                    machine_project_id : param_machine_project_id,
                    produce_start_datetime : param_produce_start_datetime,
                    produce_end_datetime : param_produce_end_datetime
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setSelectProduceInputYN(typeof (response.data)[0].produce_input_yn === 'undefined'? "":(response.data)[0].produce_input_yn);
            setSelectProduceItemUseYN(typeof (response.data)[0].produce_item_use_yn === 'undefined'? "":(response.data)[0].produce_item_use_yn);
            setSelectProduceCount(typeof (response.data)[0].produce_count === 'undefined' || Number((response.data)[0].produce_count) === 0? 0:(response.data)[0].produce_count);
            setSelectProduceCompleteCount(typeof (response.data)[0].produce_complete_count === 'undefined' || Number((response.data)[0].produce_complete_count) === 0? (response.data)[0].produce_count:(response.data)[0].produce_complete_count);
            if(String((response.data)[0].produce_input_yn) === 'Y'){
                setSelectProduceErrorCount(typeof (response.data)[0].produce_error_count === 'undefined' || Number((response.data)[0].produce_error_count) === 0? '0':(response.data)[0].produce_error_count);
            }else{
                setSelectProduceErrorCount(typeof (response.data)[0].produce_error_count === 'undefined' || Number((response.data)[0].produce_error_count) === 0? '':(response.data)[0].produce_error_count);
            }
            setSelectProduceInputUserID(typeof (response.data)[0].produce_input_user_id === 'undefined'? "":String((response.data)[0].produce_input_user_id));
            setSelectProduceInputDateTime(typeof (response.data)[0].produce_input_datetime === 'undefined'? "":Moment((response.data)[0].produce_input_datetime).format('YYYY-MM-DD HH:mm:ss'));
            
            // 검색으로 들어오면 프로젝트 조회.
            if(fixProject !== ''){
                const optionArray = response.data.map((item, index) => 
                    ({ value: item.machine_id+'$'+item.machine_project_id+'$'+Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')+'$'+Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss'), label: item.machine_name + ' / ' + item.project_name + ' / ' + item.produce_count+'EA' })
                );
                
                setProjectOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
            }
            
            let array = response.data.map((item, index) => ({
                produce_input_item_seq: (typeof item.produce_input_item_seq === 'undefined'? "":String(item.produce_input_item_seq)),
                produce_input_item_id: (typeof item.produce_input_item_id === 'undefined'? "":String(item.produce_input_item_id)),
                produce_input_item_name: (typeof item.produce_input_item_name === 'undefined'? "":String(item.produce_input_item_name)),
                produce_input_plan_count: (typeof item.produce_input_plan_count === 'undefined'? "0":String(item.produce_input_plan_count)),
                produce_input_count: (
                    (response.data)[0].produce_input_yn === "Y"?
                    Number(item.produce_input_count)
                    :
                    (Number(item.produce_input_plan_count) >= Number(item.produce_input_item_use_stock)?Number(item.produce_input_item_use_stock):Number(item.produce_input_plan_count))
                ),
                produce_input_item_spec: (typeof item.produce_input_item_spec === 'undefined'? "":String(item.produce_input_item_spec)),
                produce_input_item_full_spec: item.produce_input_item_spec,
                produce_input_item_width: item.produce_input_item_width,
                produce_input_item_depth: item.produce_input_item_depth,
                produce_input_item_height: item.produce_input_item_height,
                produce_input_item_use_stock: item.produce_input_item_use_stock,
                produce_input_item_dp_use_stock: item.produce_input_item_dp_use_stock,
                produce_input_item_unit_name: item.produce_input_item_unit_name
            }));
            array = array.filter((element) => element.produce_input_plan_count > 0);
            setInputItemRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const handleSave = () => {
        let msg = '';

        if(selectProduceInputYN === 'Y'){
            msg = '이미 실적 등록된 프로젝트 입니다.'
        }else if(selectProject === '' || selectProject === 0){
            msg = '프로젝트가 선택되지 않았습니다.'
        }else if(selectProduceCompleteCount < 0){
            msg = '양품수량이 음수가 될 수 없습니다.'
        }else if(selectProduceErrorCount < 0){
            msg = '불량수량이 음수가 될 수 없습니다.'
        }

        if(InputItemRows.length > 0 && msg === ''){ // 출하품목 검사
            for(let i = 0; i < InputItemRows.length; i++) {
                const input_count = InputItemRows[i].produce_input_count;

                if(input_count < 0) {
                    msg = '사용품목 수량이 음수가 될 수 없습니다.';
                    break;
                }
            }
        }
        
        if(msg !== ''){
            alert(msg);
        }else{
            if (appStore.loading) return;
            appStore.setLoading(true);
            
            axios.post("/api/p/MachineProducePerformance/Update", {selectProject, selectProduceCount, selectProduceCompleteCount, selectProduceErrorCount, InputItemRows},
            { withCredentials: true })
            .then(function (response) {
                if(response.data === "N"){
                    alert('정상적으로 생산 실적이 등록 되었습니다.');
                    setSearchProject(selectProject);
                    //window.location.reload();
                }else{
                    alert("생산 실적을 등록 할 수 없습니다.\n"+response.data);
                }
            })
            .catch(function (error) {
                appStore.capture();
            })
            .finally(() => {
                appStore.setLoading(false); 
            });
        }

    };

    const handleCancel = () => {
        let msg = '';
        if(selectProduceItemUseYN === 'Y'){
            msg = '생산된 제품이 이미 사용/출하 되었으므로 실적을 취소할 수 없습니다.'
        }

        if(msg !== ''){
            alert(msg);
        }else{
            const question = window.confirm("생산 실적을 취소 하시겠습니까?");
            if(question){
                if (appStore.loading) return;
                appStore.setLoading(true);
                
                axios.post("/api/p/MachineProducePerformance/Cancel", {selectProject},
                { withCredentials: true })
                .then(function (response) {
                    if(response.data === "N"){
                        alert('정상적으로 생산이 실적 취소 되었습니다.');
                        setSearchProject(selectProject);
                        //window.location.reload();
                    }else{
                        alert("생산 실적을 취소 할 수 없습니다.\n"+response.data);
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false); 
                });
            }
        }
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="M_menubox" style={ { height: '50px' } }>
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={ { float: 'right' } }>
                        {selectProduceInputYN === 'N'?
                        <>
                        <Button 
                            onClick={handleSave}
                            className="M_btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            실적등록
                        </Button>
                        </>:
                        selectProduceInputYN === 'Y'?
                        <>
                        <Button 
                            onClick={handleCancel}
                            className="M_btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "orange", 
                                backgroundColor: "orange",
                                ":hover": { boxShadow: "2px 2px 2px orange" , backgroundColor: "orange", borderColor: "orange"}
                            }} 
                            variant="outlined">
                            실적취소
                        </Button>
                        </>
                        :
                        <></>}
                    </div>
                </div>
            </div>
            
            <div className="M_contents">
                {fixProject !== ''?
                <></>
                :
                <div>
                    <div className="M_menu-keyword-sub-keyword" style={ { float:'left', width: '50%', paddingBottom: '10px' } }>
                        <select placeholder="일자" value={selectDateType} onChange={(e) => setSelectDateType(e.target.value) }>
                            {dateTypeOption.map((item) => (
                                <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="M_menu-keyword-sub-keyword" style={ { float:'right', paddingLeft: '10px', width: '50%' } }>
                        <input type="date" placeholder="일자" value={selectDate} onChange={(e) => setSelectDate(e.target.value) } style={ { width: '100%' } } />
                    </div>
                </div>}
                <div className="M_menu-keyword-sub-keyword" style={ { paddingBottom: '10px' } }>
                    <select placeholder="프로젝트" value={selectProject} onChange={(e) => setSelectProject(e.target.value) }>
                        {projectOption.map((item) => (
                            <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                    </select>
                </div>
                <div style={ { display: 'block' } }>
                    <table style={ { width: '100%', textAlign: 'center' } }>
                        <tbody>
                        <tr>
                            <td>
                                <span style={ { fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>생산수량</span>
                            </td>
                            <td>
                                <span style={ { fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>양품수량</span>
                            </td>
                            <td>
                                <span style={ { fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>불량수량</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" inputMode="numeric" style={ { width: '85px', height: '30px', fontSize: '17px', textAlign: 'right', fontWeight: 'bold', paddingRight: '5px' } } value={selectProduceCount} disabled />
                            </td>
                            <td>
                                <input type="text" inputMode="numeric" style={ { width: '85px', height: '30px', fontSize: '17px', textAlign: 'right', fontWeight: 'bold', paddingRight: '5px' } } value={selectProduceCompleteCount} onChange={(e) => {  const val = e.target.value;  if (/^\d*$/.test(val)) {  ProduceCompleteCountUpdate(e); } } } disabled={selectProduceInputYN !== 'N'} />
                            </td>
                            <td>
                                <input type="text" inputMode="numeric" style={ { width: '85px', height: '30px', fontSize: '17px', textAlign: 'right', fontWeight: 'bold', paddingRight: '5px' } } value={selectProduceErrorCount} onChange={(e) => {  const val = e.target.value;  if (/^\d*$/.test(val)) { ProduceErrorCountUpdate(e); } } } disabled={selectProduceInputYN !== 'N'} />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                { InputItemRows.length == 0 ?
                <></>
                :
                <>
                <div style={ { display: 'block' } }>
                    <p style={ { fontSize: '20px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>사용 품목</p>
                </div>
                
                <div style={ { display: 'block' } }>
                    {InputItemRows.map((item) => (
                        <div style={ { paddingBottom: '10px' } }>
                            <span style={ { fontSize: '17px' } }>{ item.produce_input_item_name} {item.produce_input_item_spec}</span>
                            <span style={ { float: 'right' } }>
                                <input type="number" style={ { width: '70px', fontSize: '15px', textAlign:'right', backgroundColor: 'white' } } value={item.produce_input_count} onChange={(e) => ProduceInputCountUpdate(item.produce_input_item_seq, e, item.produce_input_item_use_stock, item.produce_input_item_dp_use_stock, item.produce_input_item_unit_name) } disabled={selectProduceInputYN !== 'N'} />
                            </span>
                        </div>
                    ))}
                </div>
                </>
                }
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MOB_MachineProducePerformanceInfo;